function GravityFormsConditionalLogic( thisForm, args ) {
	let that = this;

	args = args || {};
	this.args = args;

	this.formId = thisForm.dataset.formid;
	this.fieldWithConditionalLogic = thisForm.querySelectorAll( '.has-conditional-logic' );
	this.fieldWithRelatedCondition = thisForm.querySelectorAll( '.conditions-related' );
	this.rules = [];

	this.init = function() {

		// On va se faire un array de règles pour savoir quoi faire quand un champs avec des conditions attachées, change de valeur
		that.rules = this.initRulesArray();

		// On va masquer de base tous champs qui on comme actionType de s'afficher
		that.hideElementToShow();

		// On va surveillez le changement de valeurs de tous les champs qui sont tag par une condition
		that.addEventListeners();
	};

	// Initier le tableau de règles
	this.initRulesArray = function( ) {
		let thisFormRules = [];

		that.fieldWithConditionalLogic.forEach( function( thisField ) {

			let thisFieldRealField = thisField.querySelector('input, select, textarea'),
				thisFieldRules = JSON.parse( thisFieldRealField.dataset.rules ),
				thisFieldAction = thisFieldRealField.dataset.actionType;

			if( thisFieldRules !== null ) {

				thisFieldRules.forEach( function( thisRule ) {

					if( thisFormRules[ 'field_' + that.formId + '_' + thisRule.fieldId ] === undefined ) {
						thisFormRules[ 'field_' + that.formId + '_' + thisRule.fieldId ] = [];
					}

					thisFormRules[ 'field_' + that.formId + '_' + thisRule.fieldId ].push( {
						id: thisField.id,
						operator: thisRule.operator,
						value: thisRule.value,
						action: thisFieldAction
					} );
				});

			}

		} );

		return thisFormRules;
	};

	// Permet de masquer les champs qui ont comme résultat de condition de s'afficher
	this.hideElementToShow = function() {
		that.fieldWithConditionalLogic.forEach( function( thisField ) {

			if( thisField.dataset.actionType === 'show' ) {
				thisField.classList.add( 'hidden' );
			}

		} );
	};

	this.showHideElement = function( el, theField, action, required ) {
		if( action === 'hide' ) {
			el.classList.add( 'hidden' );

			if( required ) { el.removeAttribute( 'required' ); }
		} else {
			el.classList.remove( 'hidden' );

			if( required ) { el.addAttribute( 'required' ); }
		}
	};

	this.testConditions = function( value, operator, compareTo ) {

		switch( operator ) {

			case 'isnot':
				return value != compareTo;
			break;

			case '>':
				return value > compareTo;
			break;

			case '<':
				return value < compareTo;
			break;

			case 'contains':
				return value.indexOf( compareTo ) !== false;
			break;

			case 'starts_with':
				return value.startsWith( compareTo );
			break;

			case 'ends_with':
				return value.endsWith( compareTo );
			break;

			case 'is':
			default:
				return value == compareTo;

		}

	};

	// Surveillez le changement de valeur de tous les champs qui sont associés à une condition
	this.addEventListeners = function() {

		that.fieldWithRelatedCondition.forEach( function( thisEl ) {
			
			thisEl.querySelector('input, select, textarea').addEventListener( 'change', function( e ) {

				let thisField = e.target,
					thisFieldValue;

				// console.log( "I've changed value, houray !" );

				// On va aller voir dans le tableau de condition si le changement de valeur répond aux conditions de ces champs là
				if( that.rules[ thisEl.id ] !== null && that.rules[ thisEl.id ] !== undefined ) {

					if( thisField.getAttribute( 'type' ) !== 'checkbox' ) {
						thisFieldValue = thisField.value;
					} else {
						thisFieldValue = thisField.checked ? thisField.value : null;
					}

					that.rules[ thisEl.id ].forEach( function( thisRule ) {

						let actionToExecute;

						if( that.testConditions( thisFieldValue, thisRule.operator, thisRule.value ) ) {
							actionToExecute = thisRule.action;
						} else {
							actionToExecute = ( thisRule.action === 'hide' ? 'show' : 'hide' )
						}

						that.showHideElement( document.getElementById( thisRule.id ), thisField, actionToExecute, thisField.dataset.defaultRequired );
					} );

				}
				
			} );

		} );
	};

	this.init();
}

export default GravityFormsConditionalLogic;